/**
 * Checks if navigator is available.
 */
export const isNavigator = typeof navigator !== "undefined"
